import { Http } from '../../../../support';

const initialState = {
  busy: false,
  data: [],
  filters: {
    page: 1,
    search: '',
  },
  result: undefined,
  error: undefined,
  pagination: {
    limit: 25,
  },
};

const change = (store, change) => {
  store.setState((state) => {
    state.admin.reportes.pacs.balance = { ...state.admin.reportes.pacs.balance, ...change };
  });
};

const list = async (store, meta = {}) => {
  try {
    store.setState((state) => {
      state.admin.reportes.pacs.balance.busy = true;
    });

    const response = await Http.get(`/app/admin/reportes/pac-balance`, {
      params: { ...meta },
    });

    store.setState((state) => {
      state.admin.reportes.pacs.balance.data = response.data;
    });
  } catch (error) {
    store.setState((state) => {
      state.admin.reportes.pacs.balance.error = error.data || error;
    });
  } finally {
    store.setState((state) => {
      state.admin.reportes.pacs.balance.busy = false;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.admin.reportes.pacs.balance = { ...initialState };
  });
};

const AdminReportesPacsBalanceListStore = {
  state: () => initialState,
  actions: { list, change, reset },
};

export default AdminReportesPacsBalanceListStore;
